export default "__VITE_ASSET__CBneWcRx__"